
export enum ETypeLien {
    Item = 1,
    Requisition = 2,
    Location = 3,
    BonTravail = 4,
    NonConformite = 5,
    ItemCommande = 6,
    ActionCorrective = 7,
    Message = 8,
    Emplacement = 9,
    Employe = 10,
    RapportSST = 11
}

export function GetName(typeLienDocument: ETypeLien): string {
    switch (typeLienDocument) {
        case ETypeLien.Item:
            return 'Item';
        case ETypeLien.Requisition:
            return 'Réquisition';
        case ETypeLien.Location:
            return 'Location';
        case ETypeLien.BonTravail:
            return 'Bon de travail';
        case ETypeLien.NonConformite:
            return 'Non-conformité';
        case ETypeLien.ItemCommande:
            return 'Commande';
        case ETypeLien.ActionCorrective:
            return 'Action corrective';
        case ETypeLien.Message:
            return 'Message';
        case ETypeLien.Emplacement:
            return 'Emplacement';
        case ETypeLien.Employe:
            return 'Employé';
        case ETypeLien.RapportSST:
            return 'Rapport SST';
    }
}
